import { useMemo } from 'react';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { uiEnvironment } from 'apps/sigma2-ui/src/constants/environment';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';

const { openaiEnabled } = uiEnvironment;

export const useExplanationsEnabled = (): boolean => {
  const { myUser } = useUser();
  const { myObservation } = useObservation();

  return useMemo(
    () => !(!openaiEnabled || !myUser || !myObservation?.showAIExplanations),
    [myObservation?.showAIExplanations, myUser],
  );
};
